/**
 * 不同的Scenario代表不同的H5容器
 * 例如wx_applet
 * todo 后续重构可以将企业微信以及其他容器的常量都迁移过来
 */
export default class H5Scenario {
  static get SCENARIO () {
    return 'h5_scenario'
  }
  static get WX_APPLET () {
    return 'wx_applet'
  }
  static get WX_APPLET_TOKEN () {
    return 'wx_applet_token'
  }
  /**
   * 1.0.1以及之前版本的小程序传递token时，使用的key为'token'，为了保证H5兼容老版本的
   * 小程序，因此要保留这个key
   * 之后的小程序版本都是使用'wx_applet_token'为key
   */
  static get COMPATIBLE_TOKEN () {
    return 'token'
  }
}
